import {
    getYearsDifference,
    isFirstDateBeforeSecond,
    isDateValid,
} from '@tgg/util';

export const validateDateOfBirth = (
    value: string,
    minAge = 16,
): string | boolean => {
    if (!isDateValid(value)) {
        return 'Enter a valid date in DD/MM/YYYY format';
    }

    const valueSplitted = value.split('/');
    const dateParts = valueSplitted.map(Number);
    const [dd, mm, yyyy] = dateParts;

    const todaysDate = new Date();

    const differenceInYearsFromToday = getYearsDifference(
        [
            todaysDate.getDate(),
            todaysDate.getMonth() + 1,
            todaysDate.getFullYear(),
        ],
        [dd, mm, yyyy],
    );
    const isGivenDateBefore1900 = isFirstDateBeforeSecond(
        [dd, mm, yyyy],
        [1, 1, 1900],
    );

    if (isGivenDateBefore1900) {
        return 'Enter a valid year of birth';
    }

    if (differenceInYearsFromToday < minAge) {
        return `You must be ${minAge} or older to join`;
    }

    return true;
};
